import actions from './actions';

const {
  GET_DIGITAL_CARDS,
  GET_DIGITAL_CARDS_ERR,
  GET_DIGITAL_CARDS_BEGIN,
  GENERATE_DIGITAL_CARD_BEGIN,
  GENERATE_DIGITAL_CARD,
  GENERATE_DIGITAL_CARD_ERR,
} = actions;

const initState = {
  digitalCards: [],
  total: 0,
  page: 1,
  limit: 10,
  loading: false,
  generating: false,
  error: null,
  generatedCard: null,
};

const digitalCardsReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_DIGITAL_CARDS:
      return {
        ...state,
        loading: false,
        digitalCards: data.results,
        total: data.totalResults,
        limit: data.limit,
        page: data.page,
      };
    case GET_DIGITAL_CARDS_BEGIN:
      return {
        ...state,
        error: null,
        loading: true,
      };
    case GET_DIGITAL_CARDS_ERR:
      return {
        ...state,
        loading: false,
        error: err,
      };
    case GENERATE_DIGITAL_CARD_BEGIN:
      return {
        ...state,
        error: null,
        generating: true,
        generatedCard: null,
      };
    case GENERATE_DIGITAL_CARD:
      return {
        ...state,
        generating: false,
        generatedCard: data,
      };
    case GENERATE_DIGITAL_CARD_ERR:
      return {
        ...state,
        generating: false,
        error: err,
      };
    default:
      return state;
  }
};

export default digitalCardsReducer;
